import { useContext } from 'react';
import { Context } from './store-provider';

export default () => useContext(Context);
